export const NILS = [undefined, null] as const;

export type Nil = (typeof NILS)[number];
export type OmitNil<T> = Exclude<T, Nil>;

export function isNotUndefined<T>(value: T) {
  return value !== undefined;
}

export function isUndefined<T>(value: T) {
  return value === undefined;
}
